import Cookies from 'universal-cookie';
import cookieConfig from '../../utils/cookieConfig';

const CookieSingleton = new Cookies();

const CookiesProvider = {
  get: (name, options) => CookieSingleton.get(name, { ...options }),

  getAll: (options) => CookieSingleton.getAll({ ...options }),

  set: (name, value, options) => CookieSingleton.set(name, value, { ...cookieConfig(), ...options }),

  remove: (name, options) => CookieSingleton.remove(name, { ...cookieConfig(), ...options }),
};

export default CookiesProvider;
